import { t } from 'i18next';
import * as z from 'zod';

z.config({
  customError: (issue) => {
    // Strings
    if (issue.code === 'too_small' && issue.minimum === 1 && issue.origin === 'string') {
      return t('errors:forms.string.non_empty');
    }

    if (issue.code === 'too_small' && issue.origin === 'string') {
      return t('errors:forms.string.min', { min: issue.minimum });
    }

    if (issue.code === 'too_big' && issue.origin === 'string') {
      return t('errors:forms.string.max', { max: issue.maximum });
    }

    // Numbers
    if (issue.code === 'too_small' && issue.origin === 'number') {
      return t('errors:forms.number.min', { min: issue.minimum });
    }

    if (issue.code === 'too_big' && issue.origin === 'number') {
      return t('errors:forms.number.max', { max: issue.maximum });
    }

    if (issue.code === 'invalid_type' && issue.expected === 'number') {
      return t('errors:forms.number.numeric');
    }

    if (issue.code === 'invalid_type' && issue.expected === 'integer') {
      return t('errors:forms.number.integer');
    }

    // Arrays
    if (issue.code === 'too_small' && issue.origin === 'array') {
      return t('errors:forms.array.min', { min: issue.minimum });
    }

    if (issue.code === 'too_big' && issue.origin === 'array') {
      return t('errors:forms.array.max', { max: issue.maximum });
    }
  },
});

export * from 'zod';
export default z;
